import PropTypes from 'prop-types';
import '../../../utils/minimal/highlight';
import { Link as RouterLink } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
// markdown plugins
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
// @mui
import { Link, Typography, Divider } from '@mui/material';
import StyledMarkdown from './styles';

// ----------------------------------------------------------------------

Markdown.propTypes = {
  sx: PropTypes.object,
};

const fixSpaces = (children) => {
  if (children && typeof children === 'string') {
    children = children.replace(/&nbsp;/g, ' ');
  }
  // if props.children is an array, we need to iterate over it and fix each string
  if (children && Array.isArray(children)) {
    // recursively fix each child
    children = children.map((child) => fixSpaces(child));
  }
  return children;
}

export default function Markdown({ sx, ...other }) {
  other.children = fixSpaces(other.children);
  return (
    <StyledMarkdown sx={sx}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw, rehypeHighlight, [remarkGfm, { singleTilde: false }]]}
        components={components}
        {...other}
      />
    </StyledMarkdown>
  );
}

// ----------------------------------------------------------------------


const components = {
  h1: ({ ...props }) => <Typography variant="h1" gutterBottom {...props} />,
  h2: ({ ...props }) => <Typography variant="h2" gutterBottom {...props} />,
  h3: ({ ...props }) => <Typography variant="h3" gutterBottom {...props} />,
  h4: ({ ...props }) => <Typography variant="h4" gutterBottom {...props} />,
  h5: ({ ...props }) => <Typography variant="h5" gutterBottom {...props} />,
  h6: ({ ...props }) => <Typography variant="h6" gutterBottom {...props} />,
  p: ({ ...props }) => <Typography paragraph {...props}/>,
  hr: ({ ...props }) => <Divider sx={{ my: 3 }} {...props} />,
  img: ({ ...props }) => <img style={{borderRadius: '8px', marginTop: '10px'}} {...props} />,
  a: ({ ...props }) => {
    const isHttp = props.href.includes('http');

    return isHttp ? (
      <Link target="_blank" rel="noopener" {...props} />
    ) : (
      <Link component={RouterLink} to={props.href} {...props}>
        {props.children}
      </Link>
    );
  },
};
